module.exports = __webpack_public_path__ + "static/img/sm_js_14.23ac99c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_14.png
// module id = kmg7
// module chunks = 1